module.exports = __webpack_public_path__ + "res/28-img_card_bg.5074713d4747e27fabd29ddf2bf2cf44.png";